<template>
  <div class="plugin-orbcomm-last-updated">
    <h6 class="mb-0"><b-badge variant="info" class="text-normal" v-translate="{date: date ? moment.utc(date).tz($tz).format('L LT') : ''}">Orbcomm Last Update: %{date}</b-badge> <b-spinner small v-if="updating" /> </h6>
  </div>
</template>

<script>
import {
  ItemService
} from '@/services/api'

export default {
  name: 'OrbcommLastUpdated',
  data() {
    return {
      date: '',
      setTimeout: null,
      timeout: 900000,
      updating: false
    }
  },
  mounted() {
    this.fetchOrbcommLastUpdated()
  },
  beforeDestroy() {
    clearTimeout(this.setTimeout)
  },
  methods: {
    fetchOrbcommLastUpdated() {
      clearTimeout(this.setTimeout)
      this.updating = true
      const params = {
        limit: 1,
        fields: 'last_position_updated_at',
        sort: [
          {
            key: 'last_position_updated_at',
            direction: 'desc'
          }
        ]
      }
      ItemService.getAll({ params })
        .then(response => {
          console.log(response.body.data)
          this.date = response.body.data[0].last_position_updated_at
          this.updating = false
          this.setTimeout = setTimeout(() => {
            this.fetchOrbcommLastUpdated()
          }, this.timeout)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.badge {
  font-weight: normal;
  letter-spacing: normal;
}
</style>
